import Record from '../Record'

export default class Store extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	/*
	static async fetch (id = null) {
	*/

	static async delete (machine_id) {
		console.log('id: ' + id)
		await Anvil.REST.delete(`/c_order/terminal/${machine_id}`)
	}

	async commit () {
		if (this._data.machine_id == null) {
			// Insert
			throw new Error('Telephelyet létrehozni nem lehet')
		} else {
			// Update
			await Anvil.REST.put(`/c_order/terminal/${this._data.machine_id}`, this._data)
		}
	}
}
